import { Outlet } from 'react-router'

import { CompanyProvider } from '@/contexts/company'

export function RoutesRootWrapper() {
  return (
    <CompanyProvider>
      <Outlet />
    </CompanyProvider>
  )
}
